<!--  -->
<template>
  <div class="sex-main">
    <div id="sex" class="sexStyle"></div>
  </div>
</template>

<script>
export default {
  name: "sexMain",
  data() {
    return {};
  },
  mounted() {
    this.drawLine();
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let sex = this.$echarts.init(document.getElementById("sex"));

      var weatherIcons = {
        Sunny: 4 + "data/asset/img/weather/sunny_128.png",
        Cloudy: 5 + "data/asset/img/weather/cloudy_128.png",
        Showers: 6 + "data/asset/img/weather/showers_128.png"
      };

      // 绘制图表
      sex.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          // top: 'middle',
          bottom: 70,
          left: "center",
          textStyle: { color: "#ffffff" }
          //   data: ["西凉", "益州", "兖州", "荆州", "幽州"]
        },
        series: [
          {
            label: {
              normal: {
                position: "inner",
                show: false
              }
            },
            label: {
              //饼图图形上的文本标签
              normal: {
                show: true,
                position: "inner", //标签的位置
                textStyle: {
                  fontWeight: 500,
                  fontSize: 10 //文字的字体大小,
                  //   color:'red'
                },
                formatter: "{d}"
              }
            },
            color: ["#0083D0", "#67EEFF"],
            type: "pie",
            radius: "80%",
            center: ["50%", "35%"],
            selectedMode: "single",

            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              { value: 1548, name: "男" },
              { value: 510, name: "女" }
            ]
          }
        ]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.sexStyle {
  width: 100%;
  height: 100%;
}
</style>
